/**
 * Page Transition Component
 * Wraps route content with a bottom-drawer slide-up animation on route changes.
 */

import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
  const location = useLocation();
  const [animating, setAnimating] = useState(false);
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    // Don't animate on initial mount
    if (prevPathRef.current === location.pathname) return;

    prevPathRef.current = location.pathname;
    setAnimating(true);

    const timer = setTimeout(() => {
      setAnimating(false);
    }, 350); // match animation duration

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <div
      className={animating ? 'page-transition-enter' : ''}
      style={{ minHeight: '100%' }}
    >
      {children}
    </div>
  );
}

export default PageTransition;
